// 2021-06-20 C0125 Add this for config base url for axio

let baseURL = 'https://api.pgebet.com/'
let version = '4.3.134'
const apkVersion = '1.5.8'

switch (location.hostname) {
  case 'localhost':
    // baseURL = 'http://localhost:1319/'
    // baseURL = 'http://localhost:8082/'
    // baseURL = 'https://pre-api.betajay.com/'
    baseURL = 'https://uat-api.pgebet.com/'
    break
  case 'www.pgebet.com':
    baseURL = 'https://api.pgebet.com/'
    break
  case 'www.pgebet.xyz':
    baseURL = 'https://api.pgebet.xyz/'
    break
  case 'www.pgebet.cc':
    baseURL = 'https://api.pgebet.cc/'
    break
  case 'www.pgebet.top':
    baseURL = 'https://api.pgebet.top/'
    break
  case 'www.pgebet.org':
    baseURL = 'https://api.pgebet.org/'
    break
  case 'www.pgebet.app':
    baseURL = 'https://api.pgebet.app/'
    break
  case 'www.pgebet.club':
    baseURL = 'https://api.pgebet.club/'
    break
  case 'uat.pgebet.com':
    baseURL = 'https://uat-api.pgebet.com/'
    break
}

// 根据环境不同导出不同的baseURL
let config = {
  baseURL: baseURL,
  version: version,
  apkVersion: apkVersion
}
export default config



//////////////////
// WEBPACK FOOTER
// ./static/config/config.js
// module id = null
// module chunks = 